export default __webpack_public_path__ + "static/media/vinyl_cat.ab6e3a13.jpg";